<template>
  <div class="row align-center">
    <div class="small-11 medium-10 large-9 columns content">
      <div class="row">
        <div class="small-12 medium-12 large-12 columns">
          <div class="row homedepart" v-if="this.$store.state.departamento?.Texto">
            <div class="small-12 medium-12 large-12 columns intro_departamento">
              <p v-html="this.$store.state.departamento?.Texto"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row align-center" v-if="cursos.length > 0">
    <div class="small-11 medium-10 large-9 columns content cursos">
      <div class="row">
        <div class="small-6 medium-4 large-4 columns"
             @click="goToCurso(curso)"
             v-for="curso in cursos"
             :key="curso.ID">
          <div class="cursos_departamento">
            <p>{{ curso.titulo }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="linha_cursos" v-if="topNoticias.length > 0"></div>
  <destaques-home
      :color-class="colorClass"
      :color="color"></destaques-home>
  <testemunhosHome></testemunhosHome>
</template>

<script>
import testemunhosHome from "@/components/testemunhoshome.vue";
import DestaquesHome from "./destaquesHome.vue";

export default {
  name: "homeDepartamento",
  components: {
    DestaquesHome,
    testemunhosHome,
  },
  data() {
    return {
      topNoticias: [],
      cursos: [],
      colorClass: null,
      color: ""
    }
  },
  inject: ["secundaryColors"],
  created() {
    if (this.$store.state.departamento == null) {
      this.fetchDepartamento();
    }
    this.getTopNoticias();
    this.getCursos();
  },
  updated() {
    if (this.colorClass == null) {
      this.colorClass = this.$store.state.departamento.Faculdade.name;
      this.color = this.secundaryColors[this.colorClass];
    }
  },
  methods: {
    getTopNoticias() {
      const request = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}/destaques?idioma=${this.$store.state.language}&limit=6`;
      fetch(request)
          .then(response => response.json())
          .then(data => {
            this.topNoticias = data.map(el => {
              let ellipsedNome = el.Nome;
              if (ellipsedNome.length > 80) {
                ellipsedNome = ellipsedNome.substring(0, 80) + "(...)";
              }
              return {
                id: el.ID,
                titulo: ellipsedNome,
                corpo: el.Texto,
                imagem: el.Imagem,
                url: el.Url
              }
            });
          })
          .catch(error => console.log(error));
    },
    fetchDepartamento() {
      let parameters = this.$store.state.language != "en" ? "" : "?idioma=en";
      const request = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}${parameters}`;
      fetch(request)
          .then(response => response.json())
          .then(data => {
            this.$store.commit("setDepartamento", data);
            this.colorClass = data.Faculdade.name;
            this.color = this.secundaryColors[this.colorClass];
          })
          .catch(error => console.log(error));
    },
    goToCurso(curso) {
      window.location = curso.url;
    },
    getCursos() {
      const request = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}/cursos?idioma=${this.$store.state.language}`;
      fetch(request)
          .then(response => response.json())
          .then(data => {
            this.cursos = data.map(el => {
              return {
                id: el.ID,
                titulo: el.post_title,
                ciclo: el.ciclo,
                grau: el.grau,
                url: el.url
              }
            });
          })
          .catch(error => console.log(error));
    }
  }
}

</script>

<style scoped>

.content {
  margin: 0 auto;
}

.content .row {
  margin-right: 0px;
  margin-left: 0px;
}

.homedepart {
  margin-right: 0px;
  margin-left: 0px;
}

.intro_departamento p {
  padding-left: 20px;
  padding-right: 20px;
  line-height: 2.2;
  font-family: Montserrat;
  font-size: 16px;
  color: #454648;
  padding-bottom: 50px;
}

.cursos_departamento p {
  font-family: "Montserrat";
  color: white;
  font-size: 20px;
  padding: 10px;
  text-align: center;
  /*color: #303083;*/
  color: v-bind("color");
  margin-bottom: 0px;
  padding-bottom: 60px;
  padding-top: 30px;
}

.cursos_departamento {
  background-color: transparent;
  margin: 0 auto;
  border-radius: 4px;
  /*border: 2px solid #303083;*/
  border: 2px solid;
  border-color: v-bind('color');
  margin-top: 15px;
}

.cursos_departamento:hover {
  cursor: pointer;
}

.cursos .row .columns {
  padding-right: 6px;
  padding-left: 6px;
}

.cursos {
  margin-top: -180px;
  padding-right: 15px;
  padding-left: 15px;
}

.cursos .row {
  margin-right: 0px;
  margin-left: 0px;
}

.linha_cursos {
  border-bottom: 5px solid #e9eaea;
}

.cursos_departamento:hover p {
  font-family: "Montserrat Semibold";
}

.cursos_departamento p {
  height: 150px;
}


/*Responsive - ecrãs desktop pequenos*/
@media (max-width: 1440px) {
  .intro_departamento p {
    padding-left: 10px;
    padding-right: 10px;
  }

  .cursos_departamento p {
    font-size: 18px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .cursos {
    margin-top: -120px;
    line-height: 1.5;
  }

  .cursos_departamento p {
    padding-top: 20px;
  }



}

@media (max-width: 1200px) {

  .intro_departamento p {
    padding-left: 0px;
    padding-right: 0px;

  }

  .intro_departamento {
    padding-right: 0px;
    padding-left: 0px;
  }

  .cursos_departamento p {
    font-size: 16px;
  }








}

/*Responsive - ipad*/
@media (max-width: 1025px) {

  .intro_departamento p {
    padding-left: 0px;
    padding-right: 0px;
  }

  .intro_departamento p {
    font-size: 15px;
  }

  .intro_departamento {
    padding-right: 0px;
    padding-left: 0px;
  }

  .content .row .columns {
    padding-right: 0px;
    padding-left: 0px;
  }

  .cursos_departamento p {
    line-height: 1.5;
    font-size: 17px;
  }

  .cursos .row .columns {
    padding-right: 3px;
    padding-left: 3px;
  }

  .cursos {
    margin-top: -130px;
    padding-right: 0px;
    padding-left: 0px;
  }

  .cursos_departamento {
    margin-top: 6px;
  }
}

@media (max-width: 850px) {
  .cursos_departamento p {
    line-height: 1.3;
    font-size: 16px;
  }

}

/*Responsive - iphone*/
@media (max-width: 767px) {
  .content {
    padding-right: 0px;
    padding-left: 0px;
    padding-top: 60px;
  }

  .content .row .columns {
    padding-right: 0px;
    padding-left: 0px;
  }

  .intro_departamento p {
    font-size: 13px;
    padding-bottom: 10px;
  }

  .cursos .row .columns {
    padding-right: 3px;
    padding-left: 3px;
  }

  .cursos_departamento p {
    font-size: 15px;
    height: 116px;
    padding-top: 20px;
    line-height: 21px;
  }

  .cursos_departamento {
    margin-top: 6px;
  }

  .content {
    padding-top: 30px;
    padding-right: 0px;
    padding-left: 0px;
  }

  .content.cursos {
    margin-top: -90px;
    margin-bottom: 20px;
  }

  .cursos_departamento p {
    height: 100px;
    line-height: 18px;
  }

  .content.cursos {
    margin-top: -45px;
  }


  .intro_departamento p {
     padding-right: 10px;
     padding-left: 10px; 
  }

  .cursos_departamento p {
    padding-top: 10px;
    font-size: 14px;
    height: 130px;
  }

}


@media (max-width: 640px) {
  .cursos_departamento p {
    height: 90px;
  }



}

</style>